import { useState, useEffect } from 'react';
import { SUDO_API_ENDPOINT } from '../utils/constants';

export interface TraderPoints {
  address: string;
  points: number;
  suiNsName: string;
}

const useLeaderboard = (): TraderPoints[] => {
  const [leaderboard, setLeaderboard] = useState<TraderPoints[]>([]);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const response = await fetch(`${SUDO_API_ENDPOINT}/leaderboard`);
        const data: TraderPoints[] = await response.json();
        setLeaderboard(data);
      } catch (error) {
        console.error('Error fetching leaderboard:', error);
      }
    };

    fetchLeaderboard();
  }, []);

  return leaderboard;
};

export default useLeaderboard;
